import { render } from "./repaymentPage.vue?vue&type=template&id=3b3cfec8&scoped=true&ts=true"
import script from "./repaymentPage.vue?vue&type=script&lang=ts"
export * from "./repaymentPage.vue?vue&type=script&lang=ts"

import "./repaymentPage.vue?vue&type=style&index=0&id=3b3cfec8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3cfec8"]])

export default __exports__